import { FiLink } from 'react-icons/fi';
import NewTooltip from '../../../atoms/NewTooltip';
import type { CaseLinks } from '../../../../types/LegalCase';
import { caseLinksDescription, escalatedFromText, escalatedToText, hasCaseLinks } from './caseLinks';

interface CaseLinkMarkerProps {
    links?: CaseLinks | null;
}

const MARKER_CLASS = 'inline-flex items-center rounded text-gray-400 hover:text-[#00B6AD] focus:text-[#00B6AD] '
    + 'focus:outline-none focus-visible:ring-1 focus-visible:ring-[#00B6AD] dark:text-slate-400 '
    + 'dark:hover:text-[#00B6AD] dark:focus:text-[#00B6AD]';

// AF-3972 extensão (R3): um marcador só na grid quando o caso tem vínculo em qualquer sentido. O
// tooltip lista os dois sentidos e o aria-label carrega o mesmo texto. Abre à direita para não ficar
// sob a sidebar e também no foco do teclado (Esc fecha).
const CaseLinkMarker = ({ links }: CaseLinkMarkerProps) => {
    if (!hasCaseLinks(links)) return null;
    const lines = [escalatedFromText(links), escalatedToText(links)].filter(Boolean);
    return (
        <NewTooltip
            alignment="right"
            openOnFocus
            content={(
                <div className="space-y-1">
                    {lines.map((line) => <p key={line}>{line}</p>)}
                </div>
            )}
        >
            <span aria-label={caseLinksDescription(links)} role="img" tabIndex={0} className={MARKER_CLASS}>
                <FiLink aria-hidden="true" size={14} />
            </span>
        </NewTooltip>
    );
};

export default CaseLinkMarker;
